/**
 * Created by asi on 03/08/17.
 */
import {environment} from "@environments/environment";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'toMediaUrl'})
export class ResourceMediaPipe implements PipeTransform {

  transform(mediaPath: string) {
    return environment.mediaBaseUrl + mediaPath;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/utils/media/resource.media.pipe.ts